import { motion } from "framer-motion";
import { FileText, NotebookText, ListChecks, ArrowUpRight } from "lucide-react";
import { CONTENT } from "../data/content";

const ICONS = {
    Script: FileText,
    "Beat Sheet": NotebookText,
    "Shot List": ListChecks,
};

export const Docs = () => (
    <section id="docs" className="border-t border-white/10 px-6 py-28 md:px-12 md:py-40" data-testid="docs-section">
        <motion.div
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
            className="mb-16 md:mb-24"
        >
            <h2 className="font-display text-6xl leading-none text-white md:text-8xl">
                Production <span className="text-outline">Documents</span>
            </h2>
            <p className="mt-6 max-w-xl font-body text-sm font-light leading-relaxed text-zinc-400">
                The paper trail behind Wakes the Deep — the screenplay, beat sheet and shot list from the production.
            </p>
        </motion.div>

        <div className="grid grid-cols-1 gap-px bg-white/10 sm:grid-cols-2 lg:grid-cols-3">
            {CONTENT.docs.map((doc, i) => {
                const Icon = ICONS[doc.category] || FileText;
                return (
                    <motion.div
                        key={doc.title}
                        initial={{ opacity: 0, y: 40 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.8, delay: i * 0.08, ease: [0.16, 1, 0.3, 1] }}
                        className="group flex min-h-64 flex-col justify-between bg-[#050505] p-8"
                        data-testid={`doc-card-${doc.category.toLowerCase().replace(/\s+/g, "-")}`}
                    >
                        <div>
                            <Icon className="h-8 w-8 text-zinc-600 transition-colors duration-300 group-hover:text-[#E50914]" />
                            <p className="mt-6 font-body text-[10px] uppercase tracking-[0.35em] text-zinc-500">
                                {doc.category}
                            </p>
                            <h3 className="mt-3 font-display text-2xl tracking-wide text-white">{doc.title}</h3>
                        </div>
                        {doc.href ? (
                            <a
                                href={doc.href}
                                target="_blank"
                                rel="noopener noreferrer"
                                data-testid={`doc-open-${doc.category.toLowerCase().replace(/\s+/g, "-")}`}
                                className="link-line mt-8 inline-flex w-fit items-center gap-1 font-body text-xs uppercase tracking-[0.25em] text-white"
                            >
                                Open <ArrowUpRight className="h-3 w-3" />
                            </a>
                        ) : (
                            <span className="mt-8 w-fit border border-white/15 px-4 py-2 font-body text-[10px] uppercase tracking-[0.3em] text-zinc-500">
                                Coming Soon
                            </span>
                        )}
                    </motion.div>
                );
            })}
        </div>
    </section>
);
